module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_garage__;